import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';

const TenantError = () => {
  const { error, logout } = useAuth();
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Organization Error
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            {error || 'Your account is not associated with a valid organization.'}
          </p>
        </div>
        <div className="flex flex-col space-y-4">
          <button
            onClick={logout}
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
          >
            Sign out
          </button>
          <Link
            to="/login"
            className="group relative w-full flex justify-center py-2 px-4 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
          >
            Return to login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TenantError;
